import React from 'react';
import logo from './logo.svg';
import './App.css';
import Quiz from './components/Quiz';
import quizData from './components/quizData';
import Answers from './components/QnA';

function App() {
const [start,setStart] = React.useState(0);

function toggle_restart(){
  setStart(0);
  console.log("restarting")
}

console.log(start)

return (
        <main>
          {start===0 
          ?
          <div className='container'>
            <div className="shape-blob"></div>
            <div className="shape-blob one"></div>
            <h1>Quizzical</h1>
            <p>Lets Test Your Knowledge</p>
            <button className='start-btn' onClick={()=>setStart(1)}>Start Quiz</button>
          </div>
          :
          <Quiz startQuiz={toggle_restart}/>
          }
        </main>  
)
 
}

export default App;
